import { createAsyncThunk } from "@reduxjs/toolkit";
// import { toast } from "react-toastify";
import apiInstance from "../../config/api";
import { toast } from "react-toastify";

function blobUrlToFile(blobUrl, filename) {
    return fetch(blobUrl)
        .then(response => response.blob())
        .then(blob => new File([blob], filename, { type: blob.type }));
}

export const createAlbum = createAsyncThunk('album/create', async (data) => {
    try {
        const { file, albumDescription, name } = data
        const formData = new FormData()
        if (file) {
            const processedImage = await blobUrlToFile(file, `albumbanner.png`);
            formData.append('file', processedImage, processedImage.name);
        }
        formData.append('name', name)
        formData.append('albumDescription', albumDescription)


        const request = await apiInstance.post("/album/api/create/profile/album", formData)
        const response = request.data

        if (response.status === 'success') {
            return response.data
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const deleteAlbum = createAsyncThunk('album/delete', async (albumId) => {
    try {
        const request = await apiInstance.delete(`/album/api/cover/:albumId${albumId}`);
        const response = request.data
        if (response.message === 'Deleted the image(s), album content, and album successfully') {
            return { albumId, status: response.status }
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const removeMediaFromAlbum = createAsyncThunk('album/remove-media', async ({ albumId, imageNames }) => {
    try {
        const request = await apiInstance.put(`/album/api/album/files/${albumId}`, { imageNames })
        const response = request.data
        if (response.message === "Delete operation completed") {
            toast.success(`Deleted ${imageNames?.length} media successfully!`)
            return { ...response, albumId }
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getAlbumDetails = createAsyncThunk('album/details', async (albumId) => {
    try {
        const request = await apiInstance.get(`/api/albums/${albumId}`);
        const response = request.data
        if (response.status === 'success') {
            return { albumId, data: response.data }

        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('album details error ; ', error.message)
        throw new Error(error.message)
    }
})

export const getUserAlbum = createAsyncThunk('album/fetch', async () => {
    try {
        const request = await apiInstance.get(`/api/albums/user/albums`);
        const response = request.data;
        // console.log('fetched album; ', response)
        if (response.message === 'Albums retrieved successfully') {
            return response.data
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getFriendAlbum = createAsyncThunk('album/friend/fetch', async (userId) => {
    try {
        const request = await apiInstance.get(`/api/albums/user/user/${userId}`);
        const response = request.data;
        if (response.message === 'Albums retrieved successfully') {
            return response.data
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getAlbumContent = createAsyncThunk('album/content', async (albumId) => {
    try {
        const request = await apiInstance.get(`/api/albums/contents/${albumId}`);
        const response = request.data
        console.log("album content; ", response)
        if (response.status === 'success') {
            const data = response.data
            return { albumId, data }

        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})